export const EMPTY_CONNECTION = "0x0000000000000000000000000000000000000000000000000000000000000000"
export const BLOCKTIME = 1